enum EnumTypeIdentified {
	NotIdentified = 0,
	Consideration = 1,
	Confirmed = 2
}
export default EnumTypeIdentified
